'use client';

import _toArray from "/codebuild/output/src2703/src/s3/01/node_modules/@babel/runtime/helpers/esm/toArray.js";
import { rem } from '../../../../utils/units-converters/rem.mjs';
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
import { colorResolver } from '../color-resolver/color-resolver.mjs';
function borderResolver(value, theme) {
  if (typeof value === "number") {
    return rem(value);
  }
  if (typeof value === "string") {
    var _value$split$filter = value.split(" ").filter(function (val) {
        return val.trim() !== "";
      }),
      _value$split$filter2 = _toArray(_value$split$filter),
      size = _value$split$filter2[0],
      style = _value$split$filter2[1],
      colorTuple = _value$split$filter2.slice(2);
    var result = "".concat(rem(size));
    style && (result += " ".concat(style));
    colorTuple.length > 0 && (result += " ".concat(colorResolver(colorTuple.join(" "), theme)));
    return result.trim();
  }
  return value;
}
export { borderResolver };